import { useQuery } from '@tanstack/react-query';
import {
  ProfilesApi,
  ProfileUsageRangeDays,
  type ProfileUsageDto,
} from '@up2stay/up2promo-api-client';

import { useCurrentWorkspace } from '@/core/store/workspace.store';

export type { ProfileUsageDto };
export type ProfileUsageRangeDaysValue = 7 | 30;

/**
 * Owner-facing profile view analytics for the ProfilesPage "Aufrufe" card.
 * `GET /api/v1/workspaces/:workspaceId/profiles/:profileId/usage?days=7|30`.
 */
export function useProfileUsage(
  profileId: string | null | undefined,
  rangeDays: ProfileUsageRangeDaysValue,
) {
  const workspace = useCurrentWorkspace();
  const workspaceId = workspace?.id;

  return useQuery({
    queryKey: ['profile-usage', workspaceId, profileId, rangeDays],
    queryFn: async (): Promise<ProfileUsageDto> => {
      if (!workspaceId || !profileId) {
        throw new Error('workspaceId and profileId required');
      }
      const res = await ProfilesApi.getUsage({
        path: { workspaceId, profileId },
        query: {
          days:
            rangeDays === 7
              ? ProfileUsageRangeDays._7
              : ProfileUsageRangeDays._30,
        },
      });
      return res.data;
    },
    enabled: Boolean(workspaceId) && Boolean(profileId),
    staleTime: 30_000,
  });
}
